export default __webpack_public_path__ + "static/media/Group 3ANTES-DEPOIIS.f1cdc8a8.png";